import { IPlayer } from ".";

export enum MATCH_EVENT {
    GOAL = 1,
    PENALTY_GOAL = 2,
    OWN_GOAL = 6,
    ASSIST = 22,
    YELLOW_CARD = 5,
    YELLOW_CARD_2ND = 4,
    RED_CARD = 3,
    VAR = 25,
    CONCEDED_PENALTIES = 28,
    INJURY = 20,
    SHOT_HIT_THE_POST = 21,
    PENALTY_SCORED = 23,
    PENALTY_MISSED = 24,
    MISSED_PENALTY = 15,
    FREE_KICK_GOAL = 13,
    DISALLOWED_GOAL = 14,
    FULL_TIME = 991,
    HALF_TIME = 990,
    EXTRA_TIME = 993,
    KICK_OFF = 995,
    LINEUP_CONFIRM = 992,
    SUBSTITUTION = 1000,
}

export const ICON_MATCH_EVENT: any = {
    GOAL: 'goal',
    OWN_GOAL: 'own-goal',
    FREE_KICK_GOAL: 'goal',
    PENALTY_GOAL: 'sports-soccer-disallow-1',
    ASSIST: 'assist',
    YELLOW_CARD: 'yellow-card',
    YELLOW_CARD_2ND: 'second-yellow-card',
    RED_CARD: 'red-card',
    VAR: 'var',
    CONCEDED_PENALTIES: 'whistle',
    INJURY: 'injury',
    SHOT_HIT_THE_POST: 'shot-in-post',
    PENALTY_SCORED: 'sports-soccer-disallow-1 failed',
    MISSED_PENALTY: 'sports-soccer-disallow-1 failed',
    DISALLOWED_GOAL: 'sports-soccer-disallow',
    SUBSTITUTION: 'sub-1',
    SUBSTITUTION_OUT: 'sub-out',
    EXTRA_TIME: 'whistle'
};

export interface IEventType {
    id: number;
    name: string;
}
export interface IEvent {
    minuteLabel: string;
    player?: IPlayer;
    playerExtra?: IPlayer;
    type: IEventType;
    fromTeam: 'home' | 'away';
    hScore?: string;
    aScore?: string;
    note?: string;
}

export interface IEventPen extends IEvent {
    status: boolean;
}